import { Controller } from "@hotwired/stimulus"

// The in-lesson Table of Contents block (TMS-789): clicking a chapter
// smooth-scrolls the reader to the linked block or heading anchor. Falls back
// to the browser's default anchor jump when the target isn't on the page.
export default class extends Controller {
  scrollToTarget(event) {
    const id = (event.currentTarget.getAttribute("href") || "").replace(/^#/, "")
    const target = id ? document.getElementById(id) : null
    if (!target) return

    event.preventDefault()
    target.scrollIntoView({ behavior: "smooth", block: "start" })
  }
}
